import React from "react";
import TestStatusTableRow from "containers/request/Initial/TestStatusTableRow";
import LabTestInfoContainerBSC from "containers/request/BSC/LabTestInfoContainerBSC";

const customTitles = {
  col1: "Test",
  col2: "Lab",
  col3: "Status",
  col1Row: "Battery Compliance"
};

const LabTestInfoBSC = ({ editable }) => {
  return (
    <LabTestInfoContainerBSC
      editable={editable}
      customTitles={customTitles}
      statusComponent={TestStatusTableRow}
    />
  );
};

export default LabTestInfoBSC;
